import { Outlet, useLocation } from "react-router-dom";
import Footer from "./Footer";
import Header from "./Header";
import Navbar from "./Navbar";

const Rootlayout = () => {
  const path = useLocation().pathname;

  if (
    path === "/login" ||
    path === "/register" ||
    path === "/reset-password" ||
    path === "/confirm-email"
  ) {
    return <Outlet />;
  }

  return (
    <>
      <Header />
      <Navbar />
      <Outlet />
      <Footer />
    </>
  );
};

export default Rootlayout;
